module.exports = __webpack_public_path__ + "img/21_97.30211826.png";